export default __webpack_public_path__ + "static/media/logo-p-gray.139fe5a4.svg";